import React from 'react';
import { View, ActivityIndicator, Text } from 'react-native';
import { Icon as AntIcon, List, type IconProps } from '@ant-design/react-native';
import colorsConfig from '@shared/config/colorsConfig';

interface MenuItemProps {
    icon: IconProps['name'];
    title: string;
    onPress?: () => void;
    className?: string;
    showArrow?: boolean;
    isLoading?: boolean;
    optionColor?: string;
}

export const OptionButton: React.FC<MenuItemProps> = ({
    icon,
    title,
    onPress,
    className = "border-b border-gray-300",
    showArrow = true,
    isLoading = false,
    optionColor = colorsConfig.colorPalette.black,
}) => {
    const renderExtra = () => {
        if (isLoading) {
            return (
                <View className="min-w-7 min-h-7 rounded-full justify-center items-center">
                    <ActivityIndicator size="small" color={colorsConfig.colorPalette.primary[500]} />
                </View>
            );
        }

        if (showArrow) {
            return (
                <View className="min-w-7 min-h-7 rounded-full justify-center items-center border border-gray-300 bg-white">
                    <AntIcon name="right" size={16} color={colorsConfig.colorPalette.primary[500]} />
                </View>
            );
        }

        return null;
    };

    return (
        <View className={`${className || ''}`}>
            <List.Item
                onPress={onPress}
                thumb={<AntIcon name={icon} size={24} color={optionColor} />}
                extra={renderExtra()}
                styles={{
                    Line: {
                        borderBottomWidth: 0,
                        borderTopWidth: 0,
                        borderLeftWidth: 0,
                        borderRightWidth: 0,
                        marginVertical: 16,
                    },
                    Content: {
                        paddingLeft: 24,

                    },
                    Thumb: {
                        marginRight: 0,
                    },
                }}>
                <Text className="text-base" style={{color: optionColor }}>
                    {title}
                </Text>
            </List.Item>
        </View>
    );
};
